// Story 17-4 — Settings: elegir cómo salen los menús de un bot con Evolution GO
// (`whatsapp.evolution-go.interactive`). Se guarda en el config del bot y el
// motor lo lee en el siguiente mensaje.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { type MenuMode, MenuModeSelect } from '@/components/whatsapp-connection/MenuModeSelect';
import { api } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';

export function MenuModeCard({
  bot,
}: {
  bot: { id: number; config: Record<string, unknown> | null };
}): React.ReactElement {
  const config = (bot.config ?? {}) as Record<string, unknown>;
  const wa = (config.whatsapp ?? {}) as Record<string, unknown>;
  const evo = (wa['evolution-go'] ?? {}) as Record<string, unknown>;
  const current: MenuMode = evo.interactive === 'native' ? 'native' : 'text';
  const [mode, setMode] = useState<MenuMode>(current);
  const qc = useQueryClient();

  const save = useMutation({
    mutationFn: (interactive: MenuMode) =>
      api.put(`/api/v1/bots/${bot.id}`, {
        config: { ...config, whatsapp: { ...wa, 'evolution-go': { ...evo, interactive } } },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.bot(bot.id) });
      void qc.invalidateQueries({ queryKey: queryKeys.bots() });
      toast.success('Modo de los menús guardado');
    },
    onError: (err) => {
      toast.error(err instanceof Error ? err.message : 'No se pudo guardar');
    },
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Menús de WhatsApp</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <MenuModeSelect
          id="settings-interactive"
          value={mode}
          onChange={setMode}
          disabled={save.isPending}
        />
        <Button onClick={() => save.mutate(mode)} disabled={save.isPending || mode === current}>
          {save.isPending ? 'Guardando…' : 'Guardar'}
        </Button>
      </CardContent>
    </Card>
  );
}
